<template>
  <TairoSidebarLayout>
    <slot />
  </TairoSidebarLayout>
</template>
